import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are not set. Please configure VITE_PUBLIC_SUPABASE_URL and VITE_PUBLIC_SUPABASE_ANON_KEY.');
}

// PKCE: OAuth sign-in comes back with a one-time ?code= that supabase-js exchanges,
// so access/refresh tokens never appear in the URL, browser history or redirect_to.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { flowType: 'pkce', detectSessionInUrl: true, persistSession: true, autoRefreshToken: true },
});

// ── Admin access-token cache ────────────────────────────────────────────────
// Admin-only edge functions verify the caller's Supabase session. We keep the
// current access token cached and expose it to admin components so their fetch
// calls can send `Authorization: Bearer <user-token>` instead of the anon key.
let cachedAccessToken = '';

supabase.auth.getSession().then(({ data }) => {
  cachedAccessToken = data.session?.access_token ?? '';
}).catch(() => { /* ignore */ });

supabase.auth.onAuthStateChange((_event, session) => {
  cachedAccessToken = session?.access_token ?? '';
});

declare global {
  interface Window {
    getCendienToken?: () => string;
  }
}

if (typeof window !== 'undefined') {
  window.getCendienToken = () => cachedAccessToken;
}
